import { Controller } from "@hotwired/stimulus";
import * as moment from 'moment';
import 'moment-timezone';
import { formSubmitWithSpinner } from "../jobCompletion";

export default class LoginController extends Controller {
    static targets = [
        "form",
        "submit",
        "timeZone"
    ];

    readonly formTarget!: HTMLFormElement;
    readonly submitTarget!: HTMLButtonElement;
    readonly timeZoneTarget!: HTMLInputElement;

    connect() {
        const timezone = moment.tz.guess();
        this.timeZoneTarget.value = timezone;

        formSubmitWithSpinner(
            this.formTarget,
            this.submitTarget,
            { eventName: 'login' }
        );
    }
}
